import timedFetch from 'middleware/timedFetch';
import { fetchOpts } from 'apis/mafia/common';

export function recordToSplunk(qs, fetcher = timedFetch('postMartyPixel')) {
  const reqUrl = `/martypixel?${qs}`;
  return fetcher(reqUrl, fetchOpts({ method: 'post' }));
}
